import { supabase } from '../../supabase'
import type {
  DatabaseRow,
  FollowUpPayload,
  FollowUpRow,
  FollowUpUpdatePayload,
  RepositoryResult,
} from '../types/database.types'
import { failure, success } from './result'

export const FollowUpsRepository = {
  async listPending(): Promise<RepositoryResult<DatabaseRow[]>> {
    const { data, error } = await supabase
      .from('pending_follow_ups')
      .select('*')
    return error ? failure(error) : success((data ?? []) as DatabaseRow[])
  },

  async findPendingByProspect(
    prospectId: string,
  ): Promise<RepositoryResult<FollowUpRow | null>> {
    const { data, error } = await supabase
      .from('follow_ups')
      .select('*')
      .eq('prospect_id', prospectId)
      .eq('status', 'pending')
      .maybeSingle()

    return error
      ? failure(error)
      : success((data ?? null) as FollowUpRow | null)
  },

  async create(
    payload: FollowUpPayload,
  ): Promise<RepositoryResult<FollowUpRow>> {
    const { data, error } = await supabase
      .from('follow_ups')
      .insert(payload)
      .select('*')
      .single()
    return error ? failure(error) : success(data as FollowUpRow)
  },

  async updatePending(
    id: string,
    payload: FollowUpUpdatePayload,
  ): Promise<RepositoryResult<FollowUpRow>> {
    const { data, error } = await supabase
      .from('follow_ups')
      .update(payload)
      .eq('id', id)
      .eq('status', 'pending')
      .select('*')
      .single()

    return error ? failure(error) : success(data as FollowUpRow)
  },

  async complete(input: {
    id: string
    outcome: string
    createNext: boolean
    nextDate: string | null
  }): Promise<RepositoryResult<null>> {
    const { error } = await supabase.rpc('complete_follow_up', {
      p_follow_up_id: input.id,
      p_outcome: input.outcome,
      p_create_next: input.createNext,
      p_next_date: input.nextDate,
    })
    return error ? failure(error) : success(null)
  },
}
